// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-Ie1","content":"styles_content__2t_T5"};